import { DodonaElement } from "@/components/meta/dodona_element";
import { property } from "lit/decorators.js";
import type { DropdownOptions, FilterOptions, SwitchOptions } from "@/components/search/filter_element";
import { search } from "@/search";

/**
 * Base class for components that manage a collection of filters
 *
 * @prop {FilterOptions} filters - The filters to manage
 * @prop {string[]} hide - The list of filter params that should be hidden
 */
export class FilterCollection extends DodonaElement {
    @property({ type: Object })
    filters: FilterOptions = { dropdowns: [], switches: [] };
    @property({ type: Array })
    hide: string[] = [];

    constructor() {
        super();
        search.filterCollections.push(this);
    }

    get dropdowns(): DropdownOptions[] {
        return this.filters.dropdowns;
    }

    get switches(): SwitchOptions[] {
        return this.filters.switches;
    }

    get visibleDropdowns(): DropdownOptions[] {
        return this.dropdowns.filter((f) => !this.hide.includes(f.param));
    }

    get visibleSwitches(): SwitchOptions[] {
        return this.switches.filter((f) => !this.hide.includes(f.param));
    }
}
